import { IVisibleTo } from "@home-health-notify/domain";
import MessageReadStatus from "./messageStatus/MessageReadStatus";
import MessageDeliveredStatus from "./messageStatus/MessageDeliveredStatus";
import MessageSentStatus from "./messageStatus/MessageSentStatus";
import { MessageDeliveryStatusBox } from "./messageStatus/MessageStatus.style";
import { useTranslation } from "hhn-commons";

interface RecipientMessageStatusProps {
  recipient: IVisibleTo;
}

export interface MessageStatusProps {
  timestamp?: number;
  showText?: boolean;
}

const RecipientMessageStatus = ({ recipient }: RecipientMessageStatusProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  if (recipient.isRead) {
    return <MessageReadStatus timestamp={recipient.readAt} />;
  }
  if (recipient.isDelivered) {
    return <MessageDeliveredStatus timestamp={recipient.deliveredAt} />;
  }
  if (recipient.isSent) {
    return <MessageSentStatus timestamp={recipient.sentAt} />;
  }
  return (
    <MessageDeliveryStatusBox>
      {tNs("acknowledgeType.pending")}
    </MessageDeliveryStatusBox>
  );
};

export default RecipientMessageStatus;
